import React, {useEffect} from 'react';
import { FormPageFieldComponentProps } from 'types/formPage';
import _ from 'lodash';
import { withFormikFormControl } from '../FormikFormControl';
import {calculateFormula} from "../../helpers/formulas";
import {insertRecordFormData, renderValue} from '../utils'
import {useFormikContext} from "formik";
import {useStore} from "../../@redux";

export type FormulaProps = FormPageFieldComponentProps & {recordData?: any};

const Formula = ({ name,details, extraConfig = {}, value, recordData }: FormulaProps) => {
  const {type, formula = '', template = '', classes = '', format_as = 'text'} = extraConfig
  const {path} = details
  const store = useStore()
  const {
    values,
    setFieldValue,
      setFieldError, errors
  } = useFormikContext();
 // const store = useStore()
 // const useValues = insertRecordFormData( recordData ? null : details.form_id || details.instance, recordData, store, true )
 const useValues = recordData || values
 const answer = calculateFormula('field',store,  format_as,formula,path,useValues,extraConfig)
    console.log('Calculating Formula', format_as,formula, details,  useValues, path, recordData, values, extraConfig, answer)
 const varValues = []
 _.each( answer.variables, (variable: any) => {
     if(variable.field) {
         let varVal = _.get(useValues, variable.field?.id)
         if ([undefined, null].includes(varVal)) varVal = _.get(useValues, variable.field?.name)
         if (variable.field?.id !== name) varValues.push(varVal)
     }
 } )
  useEffect( () => {
    if(value !== answer.result){
        setFieldValue(name,answer.result)
    }
  }, [JSON.stringify(varValues)])

      console.log('Formula Field', extraConfig.render_as,extraConfig.format_as, name, type,template, formula, answer, value, varValues, answer.variables)
  return <div className={classes}>{renderValue(value, extraConfig)}</div>
};

export default withFormikFormControl({  })(Formula);
